import React, {useCallback} from 'react';
import {Select, ListItem, Text, SelectValue, Layout} from '@phonectas/unifon-ui-kit';

interface DefaultFilterSelectProps {
	value: string[];
	onChange: (val: string[]) => void;
	t: (key: string) => string;
}

const DefaultFilterSelect: React.FC<DefaultFilterSelectProps> = ({value, onChange, t}) => {
	const filterOptions = [
		{value: 'BN_CALL_LOG', label: 'BN - Calls'},
		{value: 'ERATE_CALL_LOG', label: 'Erate - call'},
		{value: 'ERATE_SYSTEM_SMS', label: 'Erate - SMS'},
		{value: 'VISMA_INVOICE', label: 'Visma invoice'},
		{value: 'THREESIXTY_COMMENT', label: '360 - Comments'},
		{value: 'THREESIXTY_NEW_CUSTOMER_RESP', label: '360 - New customer responsible'},
		{value: 'THREESIXTY_NEW_SAF_VALUE', label: '360 - SAF'},
		{value: 'THREESIXTY_OUTGOING_SMS', label: '360 - Outgoing SMS'},
		{value: 'THREESIXTY_OUTGOING_TRUSTPILOT', label: '360 - Trustpilot'},
		{value: 'THREESIXTY_INCIDENT_LOG', label: '360 - Incident log'},
	];

	const handleChange = useCallback(
		(val: SelectValue, _e: React.SyntheticEvent, _name: string) => {
			let newSelectedValues: string[] = [];
			if (Array.isArray(val)) {
				newSelectedValues = val as string[];
			} else if (typeof val === 'string') {
				newSelectedValues = [val];
			}
			onChange(newSelectedValues);
		},
		[onChange]
	);

	return (
		<Layout fullWidth direction="column" gap="xs">
			<Text variant="body1" color="textSecondary">{t('Custom filter')}</Text>
			<Select
				value={value}
				onChange={handleChange}
				multiple
				fullWidth
				placeholder={t('All')}
			>
				{filterOptions.map(option => {
					const isSelected = value.includes(option.value);
					/* i18next-extract-disable-next-line */
					return (
						<ListItem
							key={option.value}
							value={option.value}
							primaryText={t(option.label)}
							selected={isSelected}
						/>
					);
				})}
			</Select>
		</Layout>
	);
}

export default DefaultFilterSelect;